import AppFlowActions from '../../constants';

/**
 *
 * @param {*} data
 */
export default function setSearchRequest(data) {
  return ({ type: AppFlowActions.SET_SEARCH_REQUEST, data });
}
